import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import SourceModal from "./SourceModal";
import { toast } from "react-toastify";
import MeetingModal from "./MeetingModal";
import SourceIcon from "./SourceIcon";
import MarketingTabs from "../AllTabs/MarketingTabs";
import ChatModal from "./ChatModal";
import visaData from "../../VisaData/b2cvisas.json";

const initialFieldValues = {
  leadId: "00000000-0000-0000-0000-000000000000",
  leadStatusId: "",
  sourceName: "Walk In",
  userId: "00000000-0000-0000-0000-000000000000",
  name: "",
  email: "",
  phoneNumber: "",
  callBack: null,
  enquiryType: "Package",
  description: "",
};

// Enquiry Type options
const enquiryTypeOptions = [
  "Package",
  "General",
  "Flights",
  "Hotels",
  "SightSeeing",
  "Visas",
  "Umrah",
  "Hajj",
];

// Custom Hook for Debounce
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

// Get Enquiry Type Color - Fixed to show different colors for each type
const getEnquiryTypeColor = (enquiryType) => {
  switch (enquiryType?.toLowerCase()) {
    case "flights":
      return "bg-soft-primary text-black"; // Light Blue
    case "hotels":
      return "bg-soft-success text-black"; // Light Green
    case "package":
      return "bg-soft-info text-black"; // Light Cyan
    case "sightseeing":
      return "bg-soft-warning text-black"; // Light Yellow
    case "visas":
      return "bg-soft-danger text-black"; // Light Red
    case "umrah":
      return "bg-soft-warning text-black"; // Light Purple
    case "hajj":
      return "bg-soft-danger text-black"; // Light Orange
    default:
      return "bg-soft-secondary text-black"; // Light Gray
  }
};

const Lead = () => {
  const { user, loading, refreshUserProfile } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [source, setSource] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [defaultStatusId, setDefaultStatusId] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [viewRecord, setViewRecord] = useState(null);
  const [meetings, setMeetings] = useState([]);
  const [isLoadingMeetings, setIsLoadingMeetings] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterStatusId, setFilterStatusId] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedLeadForShare, setSelectedLeadForShare] = useState(null);
  const [shareablePackages, setShareablePackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [isLoadingPackages, setIsLoadingPackages] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [selectedPackageDetails, setSelectedPackageDetails] = useState(null);
  const [showVisaSearchModal, setShowVisaSearchModal] = useState(false);
  const [selectedVisa, setSelectedVisa] = useState(null);
  const [visaSearchTerm, setVisaSearchTerm] = useState("");
  const [filteredVisas, setFilteredVisas] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const pdfTemplateRef = useRef(null);
  const [showFollowUpConfirm, setShowFollowUpConfirm] = useState(false);
  const [showFollowUpValidation, setShowFollowUpValidation] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const debouncedSearchKeyword = useDebounce(searchKeyword, 300);
  // Add this function inside your Lead.js component

  const handleWhatsappClick = async (lead) => {
    // 1. Refresh profile to get the latest connects count
    const updatedProfile = await refreshUserProfile();

    // 2. Check if connects are available
    if (updatedProfile && updatedProfile.connects > 0) {
      // 3a. If connects are available, proceed to open the share modal
      handleOpenShareModal(lead);
    } else {
      // 3b. If no connects, show an error message
      toast.error(
        "You have no WhatsApp connects left. Please recharge to continue."
      );
    }
  };
  const GetData = async (pageNumber) => {
    setIsLoadingData(true);
    let resourceUrl = `${config.GETLEADBYCOMPANY}/${user.cid}?PageNumber=${pageNumber}&PageSize=${pageSize}`;

    if (debouncedSearchKeyword) {
      resourceUrl += `&search=${encodeURIComponent(debouncedSearchKeyword)}`;
    }

    if (filterStatusId) {
      resourceUrl += `&leadStatusId=${filterStatusId}`;
    }

    try {
      const res = await apiService.getAll(resourceUrl);

      if (res.data) {
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setPageSize(res.pageSize);
        setTotalPages(res.totalPages);
        setTotalRecords(res.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLists([]);
      setTotalRecords(0);
      setTotalPages(0);
    } finally {
      setIsLoadingData(false);
    }
  };

  const GetSource = async () => {
    try {
      const res = await apiService.getAll(`${config.GETSOURCE}`);
      setSource(res.data);
    } catch (error) {
      console.error("Error fetching sources:", error);
      setSource([]);
    }
  };

  const GetLeadStatus = async () => {
    try {
      const res = await apiService.getAll(
        `${config.GETLEADSTATUSBYCOMPANY}/${user?.cid}`
      );
      setLeadStatus(res.data);

      // Find and store the "New" status ID
      const newStatus = res.data.find((status) =>
        status.leadStatusName?.toLowerCase().includes("new")
      );

      if (newStatus) {
        setDefaultStatusId(newStatus.leadStatusId);
        // Auto-set to "New" for new leads
        if (!recordForEdit) {
          setValues((prev) => ({
            ...prev,
            leadStatusId: newStatus.leadStatusId,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching lead statuses:", error);
      setLeadStatus([]);
    }
  };

  // useEffect(() => {
  //   // The check for `user` inside is still important
  //   if (user && !loading) {
  //     GetSource();
  //     GetLeadStatus();
  //     GetData(1);
  //   }
  // }, [user?.cid, loading]);

  // useEffect(() => {
  //   if (user && !loading) {
  //     setPageNumber(1);
  //     GetData(1);
  //   }
  // }, [debouncedSearchKeyword, filterStatusId]);
  const getFilteredLeadStatus = (isEditMode = false) => {
    if (isEditMode) {
      return leadStatus; // Show all statuses in edit mode
    }

    // In add mode, only show "New" and "Follow Up" statuses
    return leadStatus.filter((status) => {
      const statusName = status.leadStatusName?.toLowerCase();
      return statusName?.includes("new") || statusName?.includes("follow up");
    });
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    } else {
      setValues({ ...initialFieldValues, userId: user?.uid });
    }
  }, [recordForEdit, user]);

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);
    setErrors({});
    setAddShow(true);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setErrors({});
    setAddShow(true);
  };

  const showViewDetails = async (lead) => {
    setViewRecord(lead);
    setShowViewModal(true);
    setIsLoadingMeetings(true);
    try {
      const response = await apiService.getById(
        `${config.GETMEETINGBYLEAD}`,
        `${lead.leadId}`
      );
      setMeetings(response.data);
    } catch (err) {
      console.error("Error fetching comments for view modal:", err);
      setMeetings([]);
    } finally {
      setIsLoadingMeetings(false);
    }
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETELEAD, itemToDelete);
        await GetData();
      } catch (error) {
        /* Handled by apiService */
      }
      handleCloseDeleteModal();
    }
  };

  // const handleOpenShareModal = (lead) => {
  //   setSelectedLeadForShare(lead);
  //   setShowShareModal(true);
  //   setShareablePackages([]);
  //   setSelectedPackage(null);
  //   setWhatsappMessage("");
  //   setSearchTerm("");
  //   setSelectedVisa(null);
  //   setSelectedCountry(null);
  // };
  const handleOpenShareModal = (lead) => {
    // If enquiry type is Flights, redirect to flights search screen
    if (lead.enquiryType === "Flights") {
      navigate("/flight/search");
      return;
    }

    setSelectedLeadForShare(lead);
    setShowShareModal(true);
    setShareablePackages([]);
    setSelectedPackage(null);
    setWhatsappMessage("");
    setSearchTerm("");
    setSelectedVisa(null);
    setSelectedCountry(null);
  };
  const handleCloseShareModal = () => {
    setShowShareModal(false);
    setSelectedLeadForShare(null);
  };

  const getPackagesForSharing = async () => {
    if (!selectedLeadForShare) return;

    setIsLoadingPackages(true);
    try {
      const packageTypeForAPI =
        selectedLeadForShare.enquiryType === "Package"
          ? "Holiday"
          : selectedLeadForShare.enquiryType;

      const resourceUrl = `${config.GETPACKAGEBYCOMAPANYID}/${user.cid}?type=${packageTypeForAPI}&searchText=${searchTerm}`;

      const res = await apiService.getAll(resourceUrl);
      if (res.data) {
        setShareablePackages(res.data);
      } else {
        setShareablePackages([]);
      }
    } catch (error) {
      console.error("Error fetching packages for sharing:", error);
      setShareablePackages([]);
    } finally {
      setIsLoadingPackages(false);
    }
  };

  useEffect(() => {
    if (showShareModal && selectedLeadForShare?.enquiryType !== "Visas") {
      getPackagesForSharing();
    }
  }, [showShareModal, searchTerm, selectedLeadForShare]);

  const handlePackageSelect = async (pkg) => {
    setSelectedPackage(pkg);
    setSelectedVisa(null);
    setSelectedPackageDetails(null);

    try {
      const fullDetails = await apiService.get(
        `${config.GETPACKAGEDETAILS}/${pkg.packageId}`
      );
      setSelectedPackageDetails(fullDetails);
    } catch (error) {
      console.error("Failed to fetch full package details:", error);
    }

    const packageLink = `https://b2c.zotrai.com/holiday-details/62765038-1f58-46b1-a872-0cb7673d1cc0`;

    const message = `Hello ${
      selectedLeadForShare?.name
    },\n\nGreetings!\n\nAs per our discussion, here is an exciting offer for you:\n\n*${
      pkg.packageName
    }*\nDuration: ${pkg.duration}\nPrice: ${
      pkg.currency
    } ${pkg.price.toLocaleString()} per person\n\nView details here: ${packageLink}\n\nLet us know if you're interested!\n\nBest Regards,\n${
      user.name
    }`;

    setWhatsappMessage(message);
  };

  const handleVisaSelect = (visa) => {
    setSelectedVisa(visa);
    setSelectedPackage(null);
    setSelectedPackageDetails(null);

    const message = `Hello ${
      selectedLeadForShare?.name
    },\n\nGreetings!\n\nAs per our discussion, here is the visa information you requested:\n\n*${
      visa.visaName
    }*\nCountry: ${selectedCountry.name}\nType: ${visa.visaType}\nEntry: ${
      visa.entry
    }\nStay Period: ${visa.stayPeriod}\nValidity: ${
      visa.validity
    }\nPrice: ${parseFloat(
      visa.adultPrice
    )} INR\n\nLet us know if you're interested!\n\nBest Regards,\n${user.name}`;

    setWhatsappMessage(message);
  };

  const handleVisaSearch = (e) => {
    const query = e.target.value;
    setVisaSearchTerm(query);

    if (query.length > 0) {
      const filtered = visaData.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredVisas(filtered);
    } else {
      setFilteredVisas([]);
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setVisaSearchTerm(country.name);
    setFilteredVisas([]);
  };

  const handleSendWhatsapp = async () => {
    if ((!selectedPackageDetails && !selectedVisa) || !selectedLeadForShare) {
      return;
    }

    setIsSending(true);

    try {
      let pdfFile = null;

      if (selectedPackageDetails) {
        // Generate PDF for package
        const input = pdfTemplateRef.current;
        const canvas = await html2canvas(input, { scale: 1 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const ratio = canvasHeight / canvasWidth;

        const imgHeight = pdfWidth * ratio;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
          position = position - pdfHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
          heightLeft -= pdfHeight;
        }

        const pdfBlob = pdf.output("blob");
        pdfFile = new File([pdfBlob], `${selectedPackage.packageName}.pdf`, {
          type: "application/pdf",
        });
      } else if (selectedVisa) {
        // Generate PDF for visa
        const pdf = new jsPDF();

        // Add visa details to PDF
        pdf.setFontSize(16);
        pdf.text(`Visa Details: ${selectedVisa.visaName}`, 20, 20);
        pdf.setFontSize(12);
        pdf.text(`Country: ${selectedVisa.visaCountryName}`, 20, 30);
        pdf.text(`Type: ${selectedVisa.visaType}`, 20, 40);
        pdf.text(`Entry: ${selectedVisa.entry}`, 20, 50);
        pdf.text(`Stay Period: ${selectedVisa.stayPeriod}`, 20, 60);
        pdf.text(`Validity: ${selectedVisa.validity}`, 20, 70);
        pdf.text(
          `Price: ${
            parseFloat(selectedVisa.adultPrice) +
            parseFloat(selectedVisa.serviceFee)
          } INR`,
          20,
          80
        );

        const pdfBlob = pdf.output("blob");
        pdfFile = new File([pdfBlob], `${selectedVisa.visaName}.pdf`, {
          type: "application/pdf",
        });
      }

      // Send to backend
      const formData = new FormData();
      const phoneNumber = selectedLeadForShare.phoneNumber;
      const formattedPhoneNumber = phoneNumber.startsWith("91")
        ? phoneNumber
        : "91" + phoneNumber;
      formData.append("CustomerPhone", formattedPhoneNumber);
      formData.append("CustomerName", selectedLeadForShare.name);
      formData.append("Caption", whatsappMessage);
      formData.append("CompanyId", user.cid);
      if (pdfFile) {
        formData.append("PdfFile", pdfFile);
      }

      await apiService.postWithFile(`${config.SENDPDF}`, formData);
      await refreshUserProfile();
      handleCloseShareModal();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to send WhatsApp message. Please try again.";

      toast.error(errorMessage);
      handleCloseShareModal();
    } finally {
      setIsSending(false);
    }
  };

  const handleSourceSubmit = () => {
    GetSource();
    setShowSourceModal(false);
  };

  const handleLeadStatusSubmit = () => {
    GetLeadStatus();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "callBack") {
      // If user clears the datetime-local input, set to null
      setValues({ ...values, [name]: value === "" ? null : value });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (validate()) {
  //     setBtnLoading(true);

  //     // Find "New" status as fallback
  //     const newStatus = leadStatus.find((status) =>
  //       status.leadStatusName?.toLowerCase().includes("new")
  //     );
  //     const defaultStatusId =
  //       newStatus?.leadStatusId || "00000000-0000-0000-0000-000000000000";

  //     var formData = {
  //       leadId: values.leadId,
  //       leadStatusId: values.leadStatusId || defaultStatusId, // Fallback to "New"
  //       sourceName: values.sourceName,
  //       userId: user?.id,
  //       name: values.name,
  //       email: values.email,
  //       phoneNumber: values.phoneNumber,
  //       callBack: values.callBack,
  //       enquiryType: values.enquiryType,
  //       description: values.description,
  //     };

  //     try {
  //       await apiService.put(config.UPDATELEAD, formData);
  //       toast.success("Lead created successfully!");
  //       await GetData(pageNumber);
  //       resetForm();
  //     } catch (error) {
  //       toast.error("Failed to create lead. Please try again.");
  //     } finally {
  //       setBtnLoading(false);
  //     }
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      // Check if this is a follow-up status
      const selectedStatus = leadStatus.find(
        (status) => status.leadStatusId === values.leadStatusId
      );
      const isFollowUpStatus = selectedStatus?.leadStatusName
        ?.toLowerCase()
        .includes("follow up");

      if (isFollowUpStatus) {
        if (!values.callBack || values.callBack === "0001-01-01T00:00:00") {
          // Show validation modal when no date/time is selected
          setShowFollowUpValidation(true);
          return;
        } else {
          // Show confirmation modal when date/time is selected
          setPendingFormData({
            leadId: values.leadId,
            leadStatusId: values.leadStatusId,
            sourceName: values.sourceName,
            userId: user?.id,
            name: values.name,
            email: values.email,
            phoneNumber: values.phoneNumber,
            callBack: values.callBack,
            enquiryType: values.enquiryType,
            description: values.description,
          });
          setShowFollowUpConfirm(true);
          return;
        }
      }

      // Proceed with normal submission for non-follow-up cases
      await submitFormData();
    }
  };

  // Separate function for actual form submission
  const submitFormData = async () => {
    setBtnLoading(true);

    const newStatus = leadStatus.find((status) =>
      status.leadStatusName?.toLowerCase().includes("new")
    );
    const defaultStatusId =
      newStatus?.leadStatusId || "00000000-0000-0000-0000-000000000000";

    var formData = pendingFormData || {
      leadId: values.leadId,
      leadStatusId: values.leadStatusId || defaultStatusId,
      sourceName: values.sourceName,
      userId: user?.id,
      name: values.name,
      email: values.email,
      phoneNumber: values.phoneNumber,
      callBack: values.callBack,
      enquiryType: values.enquiryType,
      description: values.description,
    };

    try {
      await apiService.put(config.UPDATELEAD, formData);
      toast.success(
        values.leadId === "00000000-0000-0000-0000-000000000000"
          ? "Lead created successfully!"
          : "Lead updated successfully!"
      );
      await GetData(pageNumber);
      resetForm();
      setShowFollowUpConfirm(false);
      setShowFollowUpValidation(false);
      setPendingFormData(null);
    } catch (error) {
      toast.error("Failed to save lead. Please try again.");
    } finally {
      setBtnLoading(false);
    }
  };

  // Handle confirmation for follow-up
  const handleConfirmFollowUp = () => {
    submitFormData();
  };

  const handleCancelFollowUp = () => {
    setShowFollowUpConfirm(false);
    setPendingFormData(null);
    setBtnLoading(false);
  };

  const handleCloseValidationModal = () => {
    setShowFollowUpValidation(false);
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };

  const handleReset = () => {
    setSearchKeyword("");
    setFilterStatusId("");
    setPageNumber(1);
  };

  const handleCommentAdded = () => {
    setShowMeetingModal(false);
    GetData(pageNumber);
  };

  const validate = () => {
    let temp = {};
    temp.name = /^[A-Za-z\s]+$/.test(values.name.trim());
    temp.phoneNumber = /^\d{7,14}$/.test(values.phoneNumber);

    // We'll handle follow-up validation in handleSubmit with modals
    // So always return true for followUp here
    temp.followUp = true;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const getStatusColor = (leadStatusName) => {
    const name = leadStatusName?.toLowerCase();

    if (name?.includes("new")) return "badge bg-primary text-white";
    if (name?.includes("replied")) return "badge bg-secondary text-white";
    if (name?.includes("closed")) return "badge bg-success text-white";
    if (name?.includes("not responding")) return "badge bg-danger text-white";
    if (name?.includes("follow up")) return "badge bg-warning text-white";
    if (name?.includes("not working")) return "badge bg-info text-white";

    return "badge bg-light text-dark";
  };

  const GetFirstPageData = () => {
    setPageNumber(1);
  };

  const GetLastPageData = () => {
    setPageNumber(totalPages);
  };

  const handleGeneratePackage = () => {
    navigate("/package");
  };

  const GetPageData = (number) => {
    if (number > 0 && number <= totalPages) {
      setPageNumber(number);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5; // Show max 5 page numbers

    let startPage = Math.max(1, pageNumber - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <>
        {startPage > 1 && (
          <>
            <li className="page-item" onClick={() => GetPageData(1)}>
              <Link to="#" className="page-link">
                1
              </Link>
            </li>
            {startPage > 2 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
          </>
        )}

        {pageNumbers.map((number) => (
          <li
            className={`page-item ${pageNumber === number ? "active" : ""}`}
            key={number}
            onClick={() => GetPageData(number)}
          >
            <Link to="#" className="page-link">
              {number}
            </Link>
          </li>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
            <li className="page-item" onClick={() => GetPageData(totalPages)}>
              <Link to="#" className="page-link">
                {totalPages}
              </Link>
            </li>
          </>
        )}
      </>
    );
  };
  useEffect(() => {
    if (user && !loading && pageNumber > 0) {
      GetLeadStatus();
      GetData(pageNumber);
    }
  }, [pageNumber, debouncedSearchKeyword, filterStatusId, user?.cid, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <MarketingTabs pageName="LEAD"></MarketingTabs>
              </div>
              <div className="card-body">
                <div className="col-12 pb-2 fs-5">Leads Management</div>
                <div className="row g-3">
                  <div className="col-xl-4 col-lg-6">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search by Name, Email, or Phone..."
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <select
                      name="filterStatusId"
                      value={filterStatusId}
                      onChange={(e) => setFilterStatusId(e.target.value)}
                      className="form-select"
                    >
                      <option value="">All Status</option>
                      {leadStatus.map((status) => (
                        <option
                          key={status.leadStatusId}
                          value={status.leadStatusId}
                        >
                          {status.leadStatusName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <div className="hstack gap-2">
                      <button className="btn btn-danger" onClick={handleReset}>
                        <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                        Reset
                      </button>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-12">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={handleAddShow}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add
                        Lead
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                {isLoadingData ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading leads...</p>
                  </div>
                ) : (
                  <>
                    <div className="table-responsive table-card mb-4">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th scope="col" style={{ width: "50px" }}>
                              S.No
                            </th>
                            <th scope="col">Lead Source</th>
                            <th scope="col">Customer</th>
                            <th scope="col">Requirement</th>
                            <th scope="col">Follow Up</th>
                            <th scope="col">Status</th>
                            <th scope="col" style={{ width: "150px" }}>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.leadId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-1">
                                    <SourceIcon sourceName={v.sourceName} />
                                    <span
                                      className={`badge ${getEnquiryTypeColor(
                                        v.enquiryType
                                      )} p-2`}
                                    >
                                      {v.enquiryType || "General"}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <h5 className="fs-14 mb-1">
                                        <Link
                                          to="#"
                                          className="text-dark"
                                          onClick={() => showViewDetails(v)}
                                        >
                                          {v.name}
                                        </Link>
                                      </h5>
                                      <p className="text-muted mb-0">
                                        <i className="ri-mail-line me-1"></i>
                                        {v.email}
                                      </p>
                                      <p className="text-muted mb-0">
                                        <i className="ri-phone-line me-1"></i>
                                        {v.phoneNumber}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td
                                  className="truncate-text"
                                  style={{ maxWidth: "150px" }}
                                >
                                  {v.description || "No description provided"}
                                </td>
                                <td>
                                  {v.callBack &&
                                  v.callBack !== "0001-01-01T00:00:00" ? (
                                    <>
                                      {moment(v.callBack).format("DD MMM YYYY")}
                                      <small className="text-muted d-block">
                                        {moment(v.callBack).format("hh:mm A")}
                                      </small>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  <span
                                    className={getStatusColor(v.leadStatusName)}
                                  >
                                    {v.leadStatusName}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-sm btn-soft-info"
                                      onClick={() => showViewDetails(v)}
                                    >
                                      <i className="ri-eye-fill"></i>
                                    </button>
                                    {v.leadStatusName?.toLowerCase() !==
                                      "closed" && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-soft-warning"
                                          onClick={() => showEditDetails(v)}
                                        >
                                          <i className="ri-pencil-fill"></i>
                                        </button>
                                        {/* <button
                                      className="btn btn-sm btn-soft-danger"
                                      onClick={() =>
                                        handleOpenDeleteModal(v.leadId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill"></i>
                                    </button> */}

                                        <button
                                          className="btn btn-sm btn-soft-success"
                                          // BEFORE: onClick={() => handleOpenShareModal(v)}
                                          // AFTER:
                                          onClick={() => handleWhatsappClick(v)}
                                          title="Share via WhatsApp"
                                        >
                                          <i className="ri-whatsapp-line"></i>
                                        </button>
                                        {v.sourceName === "ChatBot" ? (
                                          <button
                                            className="btn btn-sm btn-soft-success"
                                            onClick={() => {
                                              setSelectedNumber(v.phoneNumber);
                                              setShowChatModal(true);
                                            }}
                                          >
                                            <i className="ri-chat-3-line"></i>
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-sm btn-soft-success"
                                            onClick={() => {
                                              setSelectedLeadId(v.leadId);
                                              setShowMeetingModal(true);
                                            }}
                                          >
                                            <i className="ri-chat-3-line"></i>
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-4">
                                <div className="text-muted">
                                  <i className="ri-search-line display-5"></i>
                                  <h5 className="mt-2">No Leads Found</h5>
                                  <p className="mb-0">
                                    {debouncedSearchKeyword || filterStatusId
                                      ? "Try adjusting your search or filter criteria."
                                      : "No leads available. Add a new lead to get started."}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {lists.length > 0 && (
                      <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                        <div className="flex-shrink-0">
                          <div className="text-muted">
                            Showing{" "}
                            <span className="fw-semibold">{lists.length}</span>{" "}
                            of{" "}
                            <span className="fw-semibold">{totalRecords}</span>{" "}
                            Results
                          </div>
                        </div>
                        <ul className="pagination pagination-separated pagination-sm mb-0">
                          <li
                            className={`page-item ${
                              pageNumber === 1 ? "disabled" : ""
                            }`}
                            onClick={() =>
                              pageNumber > 1 && GetPageData(pageNumber - 1)
                            }
                          >
                            <Link to="#" className="page-link">
                              Previous
                            </Link>
                          </li>
                          {renderPageNumbers()}
                          <li
                            className={`page-item ${
                              pageNumber === totalPages ? "disabled" : ""
                            }`}
                            onClick={() =>
                              pageNumber < totalPages &&
                              GetPageData(pageNumber + 1)
                            }
                          >
                            <Link to="#" className="page-link">
                              Next
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {selectedPackageDetails && (
          <div
            style={{ position: "absolute", left: "-9999px", width: "210mm" }}
          >
            <div ref={pdfTemplateRef}>
              <PremiumModernTemplate
                packageData={selectedPackageDetails}
                user={user}
              />
            </div>
          </div>
        )}

        {/* Add/Edit Modal */}
        <Modal
          show={addShow}
          onHide={handleAddClose}
          centered
          size="lg"
          className="fade"
        >
          <Modal.Header className="bg-primary p-3">
            <Modal.Title className="text-white">
              {values.leadId === "00000000-0000-0000-0000-000000000000"
                ? "Add New Lead"
                : "Edit Lead"}
            </Modal.Title>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleAddClose}
              aria-label="Close"
            ></button>
          </Modal.Header>
          <form onSubmit={handleSubmit} noValidate>
            <Modal.Body>
              <div className="row g-3">
                <div className="col-md-4 mb-3">
                  <label htmlFor="name" className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={values.name}
                    onChange={handleInputChange}
                    maxLength={45}
                    className={`form-control ${
                      errors.name === false ? "is-invalid" : ""
                    }`}
                    placeholder="Enter name"
                  />
                  {errors.name === false && (
                    <div className="invalid-feedback">
                      Please enter a valid name
                    </div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleInputChange}
                    className={`form-control ${
                      errors.phoneNumber === false ? "is-invalid" : ""
                    }`}
                    placeholder="Enter phone number"
                    maxLength={14}
                  />
                  {errors.phoneNumber === false && (
                    <div className="invalid-feedback">
                      Please enter a valid phone number
                    </div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    name="email"
                    value={values.email}
                    onChange={handleInputChange}
                    maxLength={45}
                    className={`form-control ${
                      errors.email === false ? "is-invalid" : ""
                    }`}
                    placeholder="Enter email"
                  />
                  {errors.email === false && (
                    <div className="invalid-feedback">
                      Please enter a valid email
                    </div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="sourceName" className="form-label">
                    Source
                  </label>
                  <select
                    name="sourceName"
                    value={values.sourceName}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value={"Walk In"}>Walk In</option>
                    <option value={"Phone Call"}>Phone Call</option>
                    <option value={"General"}>General</option>
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="enquiryType" className="form-label">
                    Enquiry Type
                  </label>
                  <select
                    name="enquiryType"
                    value={values.enquiryType}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    {enquiryTypeOptions.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-4 mb-3">
                  <label htmlFor="leadStatusId" className="form-label">
                    Status
                  </label>
                  <select
                    name="leadStatusId"
                    value={values.leadStatusId || defaultStatusId} // Always show "New" if empty
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    {leadStatus.map((st) => (
                      <option key={st.leadStatusId} value={st.leadStatusId}>
                        {st.leadStatusName}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div className="col-md-4 mb-3">
                  <label htmlFor="leadStatusId" className="form-label">
                    Status
                  </label>
                  <select
                    name="leadStatusId"
                    value={values.leadStatusId || defaultStatusId}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    {/* Use filtered lead status based on whether we're in edit mode */}
                    {getFilteredLeadStatus(recordForEdit !== null).map((st) => (
                      <option key={st.leadStatusId} value={st.leadStatusId}>
                        {st.leadStatusName}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-4 mb-3">
                  <label htmlFor="callBack" className="form-label">
                    Follow Up
                  </label>
                  <input
                    type="datetime-local"
                    name="callBack"
                    value={
                      values.callBack
                        ? moment(values.callBack).format("YYYY-MM-DDTHH:mm")
                        : ""
                    }
                    min={moment().format("YYYY-MM-DDTHH:mm")}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div> */}
                {/* Conditionally render Follow Up field based on selected status */}
                {values.leadStatusId &&
                  leadStatus.find(
                    (status) =>
                      status.leadStatusId === values.leadStatusId &&
                      status.leadStatusName?.toLowerCase().includes("follow up")
                  ) && (
                    <div className="col-md-4 mb-3">
                      <label htmlFor="callBack" className="form-label">
                        Follow Up <span className="text-danger">*</span>
                      </label>
                      <input
                        type="datetime-local"
                        name="callBack"
                        value={
                          values.callBack
                            ? moment(values.callBack).format("YYYY-MM-DDTHH:mm")
                            : ""
                        }
                        min={moment().format("YYYY-MM-DDTHH:mm")}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  )}
                <div className="col-md-8 mb-3">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <textarea
                    name="description"
                    value={values.description}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter description"
                    rows="2"
                    maxLength="300"
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleAddClose}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={btnLoading}
                >
                  {btnLoading
                    ? "Saving..."
                    : values.leadId === "00000000-0000-0000-0000-000000000000"
                    ? "Add Lead"
                    : "Update Lead"}
                </button>
              </div>
            </Modal.Footer>
          </form>
        </Modal>

        {/* Enhanced View Modal with Compact Design */}
        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          centered
          size="md"
          className="lead-detail-modal"
        >
          <Modal.Header className="bg-light p-2" closeButton>
            <Modal.Title className="fs-6 text-primary">
              <i className="ri-user-line me-1"></i>
              Lead Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            {viewRecord && (
              <div className="lead-detail-container">
                <div className="lead-header bg-primary text-white p-2 rounded-top position-relative">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="flex-grow-1">
                      <h5 className="mb-0 text-white">{viewRecord.name}</h5>
                      <small className="d-block">
                        <i className="ri-mail-line me-1"></i>
                        {viewRecord.email}
                      </small>
                      <small className="d-block mt-1">
                        <i className="ri-phone-line me-1"></i>
                        {viewRecord.phoneNumber}
                      </small>
                    </div>
                  </div>

                  <div className="position-absolute top-0 end-0 m-2">
                    <span
                      className="badge bg-white text-primary fs-6 p-2 fw-bold"
                      style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.2)" }}
                    >
                      {viewRecord.enquiryType || "General"}
                    </span>
                  </div>
                </div>

                <div className="lead-details p-2">
                  <div className="row g-1">
                    <div className="col-6 mb-1">
                      <div className="detail-item small">
                        <i className="ri-shield-user-line text-primary me-1"></i>
                        <strong>Source:</strong>{" "}
                        <SourceIcon sourceName={viewRecord.sourceName} />
                      </div>
                    </div>
                    <div className="col-6 mb-1">
                      <div className="detail-item small">
                        <i className="ri-time-line text-primary me-1"></i>
                        <strong>Status:</strong>{" "}
                        <span
                          className={getStatusColor(viewRecord.leadStatusName)}
                        >
                          {viewRecord.leadStatusName}
                        </span>
                      </div>
                    </div>

                    <div className="col-6 mb-1">
                      {viewRecord.createdDate && (
                        <div className="detail-item small">
                          <i className="ri-file-text-line text-primary me-1"></i>
                          <strong>Created:</strong>{" "}
                          {moment
                            .utc(viewRecord.createdDate)
                            .local()
                            .format("DD MMM YYYY")}
                        </div>
                      )}
                    </div>
                    <div className="col-6 mb-1">
                      {viewRecord.callBack &&
                        viewRecord.callBack !== "0001-01-01T00:00:00" && (
                          <div className="detail-item small">
                            <i className="ri-alarm-warning-line text-warning me-1"></i>
                            <strong>Follow Up:</strong>{" "}
                            {moment(viewRecord.callBack).format("DD MMM YYYY")}
                          </div>
                        )}
                    </div>

                    {viewRecord.description && (
                      <div className="col-12 mb-1">
                        <div className="detail-item small">
                          <i className="ri-file-text-line text-primary me-1"></i>
                          <strong>Description:</strong>
                          <div
                            className="mt-1 small"
                            style={{
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              maxHeight: "150px",
                              overflowY: "auto",
                            }}
                          >
                            {viewRecord.description}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <hr className="my-2" />
                <h6 className="mb-2">
                  <i className="ri-chat-3-line me-1"></i>
                  Comments
                </h6>
                {isLoadingMeetings ? (
                  <div className="text-center py-2">
                    <div
                      className="spinner-border spinner-border-sm text-primary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : meetings.length > 0 ? (
                  <div
                    className="comments-container"
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {meetings.map((meeting) => (
                      <div
                        key={meeting.meetingId}
                        className="comment-card card mb-1 border-0 shadow-sm"
                      >
                        <div className="card-body p-2">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <p className="mb-1 text-dark small">
                                {meeting.comment}
                              </p>
                              <small className="text-muted d-block">
                                <i className="ri-user-line me-1"></i>
                                {meeting.userName || "Unknown User"}
                              </small>
                              <small className="text-muted">
                                <i className="ri-time-line me-1"></i>
                                {moment
                                  .utc(meeting.meetingTime)
                                  .local()
                                  .format("DD MMM YYYY, hh:mm A")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-2 bg-light rounded small">
                    <i className="ri-chat-off-line me-1"></i>
                    No comments found
                  </div>
                )}
              </div>
            )}
          </Modal.Body>
          {/* <Modal.Footer className="p-2 bg-light">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setShowViewModal(false);
                setSelectedLeadId(viewRecord.leadId);
                setShowMeetingModal(true);
              }}
            >
              <i className="ri-chat-3-line me-1"></i>
              Add Comment
            </button>
          </Modal.Footer> */}
        </Modal>

        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />

        <SourceModal
          show={showSourceModal}
          onHide={() => setShowSourceModal(false)}
          onSourceCreated={handleSourceSubmit}
        />

        <MeetingModal
          show={showMeetingModal}
          onHide={() => setShowMeetingModal(false)}
          leadId={selectedLeadId}
          onCommentAdded={handleCommentAdded}
        />
        <ChatModal
          show={showChatModal}
          onHide={() => setShowChatModal(false)}
          phoneNumber={selectedNumber}
        />
      </div>

      {/* Share Modal */}
      <Modal
        show={showShareModal}
        onHide={handleCloseShareModal}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title>
            <div className="d-flex align-items-center">
              <i className="ri-whatsapp-line me-2 text-success"></i>
              <div>
                <h5 className="mb-0">
                  Share with {selectedLeadForShare?.name}
                </h5>
                <small className="text-muted">
                  Enquiry for: {selectedLeadForShare?.enquiryType}
                </small>
              </div>
            </div>
          </Modal.Title>
          {selectedLeadForShare?.enquiryType === "Visas" ? (
            <button
              className="btn btn-primary ms-3"
              onClick={() => setShowVisaSearchModal(true)}
            >
              Search Visas
            </button>
          ) : (
            <button
              className="btn btn-primary ms-3"
              onClick={handleGeneratePackage}
            >
              Generate New Package
            </button>
          )}
        </Modal.Header>
        <Modal.Body>
          {selectedLeadForShare?.enquiryType === "Visas" ? (
            <div className="row">
              <div className="col-md-7">
                <div className="customer-selection-container">
                  <div className="search-bar mb-3">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri-search-line"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search visas by country..."
                        value={visaSearchTerm}
                        onChange={handleVisaSearch}
                      />
                    </div>
                  </div>

                  {filteredVisas.length > 0 && (
                    <div className="list-group mb-3">
                      {filteredVisas.map((country) => (
                        <button
                          key={country.id}
                          type="button"
                          className="list-group-item list-group-item-action"
                          onClick={() => handleCountrySelect(country)}
                        >
                          <img
                            src={`https://flagcdn.com/w40/${country.flagSrc.toLowerCase()}.png`}
                            alt={country.name}
                            className="me-2"
                            style={{ width: "20px" }}
                          />
                          {country.name}
                        </button>
                      ))}
                    </div>
                  )}

                  {selectedCountry ? (
                    <div>
                      <h6 className="mb-3">
                        Available Visas for {selectedCountry.name}
                      </h6>
                      <div className="list-group">
                        {selectedCountry.visas.map((visa) => (
                          <button
                            key={visa.visaId}
                            type="button"
                            className={`list-group-item list-group-item-action ${
                              selectedVisa?.visaId === visa.visaId
                                ? "active"
                                : ""
                            }`}
                            onClick={() => handleVisaSelect(visa)}
                          >
                            <div className="d-flex w-100 justify-content-between">
                              <h5 className="mb-1 ">{visa.visaName}</h5>
                              <small>{parseFloat(visa.adultPrice)} INR</small>
                            </div>
                            <p className="mb-1">
                              Type: {visa.visaType} | Entry: {visa.entry}
                            </p>
                            <small>
                              Stay: {visa.stayPeriod} | Validity:{" "}
                              {visa.validity}
                            </small>
                          </button>
                        ))}
                      </div>

                      {/* {selectedCountry.visaDocuments &&
                        selectedCountry.visaDocuments.length > 0 && (
                          <div className="mt-3">
                            <h6>Required Documents</h6>
                            <ul className="list-group">
                              {selectedCountry.visaDocuments.map(
                                (doc, index) => (
                                  <li key={index} className="list-group-item">
                                    {doc.documentName}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        )} */}
                    </div>
                  ) : (
                    <div className="text-center py-5 bg-light rounded">
                      <i className="ri-passport-line display-4 text-muted mb-3"></i>
                      <h5 className="mt-2">Search for Visas</h5>
                      <p className="text-muted">
                        Enter a country name to search for available visas.
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-5">
                <div className="campaign-details-container">
                  <h5 className="mb-3">
                    <i className="ri-edit-line me-1"></i> Compose Message
                  </h5>
                  {selectedVisa ? (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">WhatsApp Message</label>
                        <textarea
                          className="form-control"
                          rows="10"
                          name="whatsappMessage"
                          value={whatsappMessage}
                          onChange={(e) => setWhatsappMessage(e.target.value)}
                          placeholder="Select a visa to generate a message..."
                        ></textarea>
                        <small className="text-muted">
                          Max 1000 characters
                        </small>
                      </div>
                      <div className="package-info-card p-3 border rounded bg-light">
                        <h6>Selected Visa Details</h6>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Name:</span>
                          <span>{selectedVisa?.visaName}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Country:</span>
                          <span>{selectedCountry.name}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Type:</span>
                          <span>{selectedVisa?.visaType}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Price:</span>
                          <span>
                            {parseFloat(selectedVisa?.adultPrice)} INR
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5 d-flex flex-column align-items-center justify-content-center h-100 bg-light rounded">
                      <i className="ri-passport-line display-4 text-muted mb-3"></i>
                      <h5 className="mt-2">No Visa Selected</h5>
                      <p className="text-muted">
                        Please search and select a visa to compose a message.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-7">
                <div className="customer-selection-container">
                  <div className="search-bar mb-3">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ri-search-line"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Search ${selectedLeadForShare?.enquiryType} packages...`}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className="list-group"
                    style={{ maxHeight: "450px", overflowY: "auto" }}
                  >
                    {isLoadingPackages ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : shareablePackages.length > 0 ? (
                      shareablePackages.map((pkg) => (
                        <a
                          key={pkg.packageId}
                          href="#"
                          className={`list-group-item list-group-item-action d-flex align-items-start ${
                            selectedPackage?.packageId === pkg.packageId
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePackageSelect(pkg);
                          }}
                        >
                          <img
                            src={
                              pkg.imageSrc ||
                              "https://via.placeholder.com/80x80?text=No+Image"
                            }
                            alt={pkg.packageName}
                            className="package-list-image me-3"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />

                          <div className="flex-grow-1">
                            <div className="d-flex w-100 justify-content-between">
                              <h5 className="mb-1">{pkg.packageName}</h5>
                              <small className="text-nowrap">
                                {moment(pkg.startedDate).format("DD MMM YYYY")}
                              </small>
                            </div>
                            <p className="mb-1 text-muted">
                              {pkg.description?.substring(0, 80)}...
                            </p>
                            <strong className="text-success">
                              {pkg.currency} {pkg.price?.toLocaleString()}
                            </strong>
                          </div>
                        </a>
                      ))
                    ) : (
                      <div className="text-center py-5 bg-light rounded">
                        <i className="ri-dropbox-line display-4 text-muted mb-3"></i>
                        <h5 className="mt-2">No Packages Found</h5>
                        <p className="text-muted">
                          No packages match the "
                          {selectedLeadForShare?.enquiryType}" enquiry type.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-5">
                <div className="campaign-details-container">
                  <h5 className="mb-3">
                    <i className="ri-edit-line me-1"></i> Compose Message
                  </h5>
                  {selectedPackage ? (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">WhatsApp Message</label>
                        <textarea
                          className="form-control"
                          rows="10"
                          name="whatsappMessage"
                          value={whatsappMessage}
                          onChange={(e) => setWhatsappMessage(e.target.value)}
                          placeholder="Select a package to generate a message..."
                        ></textarea>
                        <small className="text-muted">
                          Max 1000 characters
                        </small>
                      </div>
                      <div className="package-info-card p-3 border rounded bg-light">
                        <h6>Selected Package Details</h6>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Name:</span>
                          <span>{selectedPackage?.packageName}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Price:</span>
                          <span>
                            {selectedPackage?.currency}{" "}
                            {selectedPackage?.price.toLocaleString()}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Duration:</span>
                          <span>{selectedPackage?.duration}</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5 d-flex flex-column align-items-center justify-content-center h-100 bg-light rounded">
                      <i className="ri-price-tag-3-line display-4 text-muted mb-3"></i>
                      <h5 className="mt-2">No Package Selected</h5>
                      <p className="text-muted">
                        Please select a package from the left to compose a
                        message.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCloseShareModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={handleSendWhatsapp}
            disabled={(!selectedPackageDetails && !selectedVisa) || isSending}
          >
            {isSending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>{" "}
                Sending...
              </>
            ) : (
              <>
                <i className="ri-whatsapp-line me-2"></i> Send WhatsApp Message
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      {/* Validation Modal - When date/time is NOT selected */}
      <Modal
        show={showFollowUpValidation}
        onHide={handleCloseValidationModal}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="bg-danger text-white">
          <Modal.Title>
            <i className="ri-error-warning-line me-2"></i>
            Follow-up Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i className="ri-calendar-close-line display-4 text-danger mb-3"></i>
            <h5 className="text-danger">Follow-up Date Missing</h5>
            <p className="mb-3">
              You have selected <strong>Follow Up</strong> status but haven't
              set a follow-up date and time.
            </p>
            <div className="alert alert-warning py-2">
              <small>
                <i className="ri-information-line me-1"></i>
                Please select a follow-up date and time to continue.
              </small>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleCloseValidationModal}
          >
            <i className="ri-edit-line me-2"></i>
            Set Follow-up Date
          </button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal - When date/time IS selected */}
      <Modal
        show={showFollowUpConfirm}
        onHide={handleCancelFollowUp}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="bg-warning">
          <Modal.Title className="text-dark">
            <i className="ri-alarm-warning-line me-2"></i>
            Confirm Follow-up
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i className="ri-calendar-check-line display-4 text-warning mb-3"></i>
            <h5>Follow-up Scheduled</h5>
            <p className="mb-2">You've set a follow-up for:</p>
            <div className="alert alert-info py-3">
              <div className="fw-bold fs-5">
                {moment(pendingFormData?.callBack).format("DD MMM YYYY")}
              </div>
              <div className="text-muted">
                at {moment(pendingFormData?.callBack).format("hh:mm A")}
              </div>
            </div>
            <p className="text-muted small mb-0">
              Are you sure you want to schedule this follow-up?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCancelFollowUp}
            disabled={btnLoading}
          >
            <i className="ri-close-line me-2"></i>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirmFollowUp}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Saving...
              </>
            ) : (
              <>
                <i className="ri-check-line me-2"></i>
                Yes, Schedule Follow-up
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      <style jsx>{`
        .lead-detail-modal .modal-content {
          border-radius: 8px;
          border: none;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }
        .detail-item {
          padding: 6px;
          background: #f8f9fa;
          border-radius: 5px;
          border-left: 3px solid #667eea;
          font-size: 0.85rem;
        }
        .comments-container::-webkit-scrollbar {
          width: 6px;
        }
        .comments-container::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 5px;
        }
        .comments-container::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 5px;
        }
        .comments-container::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        .comment-card {
          font-size: 0.8rem;
        }
        .package-list-image {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 8px;
          flex-shrink: 0;
        }
      `}</style>
    </div>
  );
};

const PremiumModernTemplate = ({ packageData, user }) => {
  if (!packageData?.package) return <div>Loading package data...</div>;

  const { package: pkg } = packageData;

  const PageSection = ({ children }) => (
    <div style={{ pageBreakInside: "avoid", marginBottom: "15px" }}>
      {children}
    </div>
  );

  const SectionHeader = ({ title }) => (
    <h3
      style={{
        color: "#4A5568",
        borderLeft: "4px solid #667eea",
        paddingLeft: "12px",
        marginBottom: "15px",
        fontSize: "1.5rem",
        pageBreakBefore: "auto",
        pageBreakAfter: "avoid",
      }}
    >
      {title}
    </h3>
  );

  const BookingTable = ({ headers, data, renderRow }) => (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.9rem",
        }}
      >
        <thead>
          <tr>
            {headers.map((header, i) => (
              <th
                key={i}
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  textAlign: "left",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{data.map(renderRow)}</tbody>
      </table>
    </div>
  );

  return (
    <div
      style={{
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#2D3748",
        padding: "10mm",
        width: "210mm",
        backgroundColor: "white",
      }}
    >
      <PageSection>
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            {user?.logo && (
              <img
                src={user.logo}
                alt="Company Logo"
                style={{
                  height: "50px",
                  background: "white",
                  padding: "5px",
                  borderRadius: "8px",
                }}
                crossOrigin="anonymous"
              />
            )}
            <div style={{ textAlign: "right", fontSize: "0.9rem" }}>
              <p style={{ margin: 0 }}>{pkg.contactName || user?.name}</p>
              <p style={{ margin: 0 }}>{pkg.contactEmail || user?.email}</p>
              <p style={{ margin: 0 }}>
                {pkg.contactPhoneNumber || user?.phoneNumber}
              </p>
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <h1
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              {pkg.packageName}
            </h1>
            <p style={{ fontSize: "1.2rem", opacity: "0.9" }}>
              {pkg.destinationsCover}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ flex: 2 }}>
            <img
              src={pkg.imageSrc}
              alt={pkg.packageName}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "12px",
              }}
              crossOrigin="anonymous"
            />
          </div>
          <div
            style={{
              flex: 1,
              background: "#F7FAFC",
              padding: "20px",
              borderRadius: "12px",
            }}
          >
            <h3
              style={{
                color: "#4A5568",
                borderBottom: "2px solid #667eea",
                paddingBottom: "10px",
                marginBottom: "20px",
              }}
            >
              Package Summary
            </h3>
            <p>
              <strong>Duration:</strong> {pkg.duration}
            </p>
            <p>
              <strong>Start Date:</strong>{" "}
              {moment(pkg.startedDate).format("MMMM Do, YYYY")}
            </p>
            <p>
              <strong>Destinations:</strong> {pkg.destinationsCover}
            </p>
            <p>
              <strong>Price:</strong> {pkg.price?.toLocaleString()}{" "}
              {pkg.currency}
            </p>
          </div>
        </div>
      </PageSection>

      <PageSection>
        <SectionHeader title="Overview" />
        <p style={{ lineHeight: "1.6" }}>{pkg.description}</p>
      </PageSection>

      {packageData.itineraries?.length > 0 && (
        <PageSection>
          <SectionHeader title="Itinerary" />
          {packageData.itineraries
            .slice()
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .map((item, index) => (
              <div
                key={index}
                style={{
                  borderLeft: "3px solid #667eea",
                  padding: "10px 20px",
                  marginBottom: "15px",
                  background: "#F7FAFC",
                  pageBreakInside: "avoid",
                }}
              >
                <h5 style={{ margin: "0 0 5px 0" }}>
                  {moment(item.date).format("MMMM Do, YYYY")} - {item.title}
                </h5>
                <p style={{ margin: "0 0 5px 0" }}>
                  <strong>Location:</strong> {item.location}
                </p>
                <p style={{ margin: "0 0 5px 0" }}>{item.description}</p>
                {item.meals && (
                  <small>
                    <strong>Meals:</strong> {item.meals}
                  </small>
                )}
                {item.note && (
                  <small style={{ display: "block" }}>
                    <strong>Note:</strong> {item.note}
                  </small>
                )}
              </div>
            ))}
        </PageSection>
      )}

      {(packageData.includes?.length > 0 ||
        packageData.excludes?.length > 0) && (
        <PageSection>
          <div style={{ display: "flex", gap: "30px" }}>
            {packageData.includes?.length > 0 && (
              <div style={{ flex: 1 }}>
                <SectionHeader title="What's Included" />
                <ul
                  style={{
                    listStyleType: "'✓ '",
                    paddingLeft: "20px",
                    margin: 0,
                  }}
                >
                  {packageData.includes.map((item, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {item.description}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {packageData.excludes?.length > 0 && (
              <div style={{ flex: 1 }}>
                <SectionHeader title="What's Excluded" />
                <ul
                  style={{
                    listStyleType: "'✗ '",
                    paddingLeft: "20px",
                    margin: 0,
                  }}
                >
                  {packageData.excludes.map((item, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {item.description}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </PageSection>
      )}

      {packageData.hotelBookings?.length > 0 && (
        <PageSection>
          <SectionHeader title="Hotel Bookings" />
          <BookingTable
            headers={["Hotel", "City", "Check-In", "Check-Out", "Room Type"]}
            data={packageData.hotelBookings}
            renderRow={(hotel, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#F7FAFC" : "white",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hotel.hotelName}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hotel.city}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(hotel.checkInDate).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(hotel.checkOutDate).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hotel.roomType}
                </td>
              </tr>
            )}
          />
        </PageSection>
      )}

      {packageData.flightBookings?.length > 0 && (
        <PageSection>
          <SectionHeader title="Flight Details" />
          {packageData.flightBookings.map((flight, index) => (
            <div
              key={index}
              style={{
                background: "#F7FAFC",
                border: "1px solid #ddd",
                padding: "15px",
                borderRadius: "8px",
                marginBottom: "15px",
                pageBreakInside: "avoid",
              }}
            >
              <h5 style={{ margin: "0 0 10px 0" }}>
                {flight.airline} - Flight {flight.flightNumber} (
                {flight.cabinClass})
              </h5>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>
                  <strong>From:</strong> {flight.departureCity} <br />{" "}
                  {moment(flight.departureDateTime).format(
                    "MMM Do, YYYY h:mm a"
                  )}
                </p>
                <p style={{ textAlign: "right" }}>
                  <strong>To:</strong> {flight.arrivalCity} <br />{" "}
                  {moment(flight.arrivalDateTime).format("MMM Do, YYYY h:mm a")}
                </p>
              </div>
            </div>
          ))}
        </PageSection>
      )}

      {packageData.sightSeeings?.length > 0 && (
        <PageSection>
          <SectionHeader title="Sightseeing" />
          <BookingTable
            headers={["Date", "Destination", "Attraction", "Description"]}
            data={packageData.sightSeeings}
            renderRow={(sight, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#F7FAFC" : "white",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(sight.date).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {sight.destination}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {sight.sightseeingName}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {sight.description}
                </td>
              </tr>
            )}
          />
        </PageSection>
      )}

      {packageData.transfers?.length > 0 && (
        <PageSection>
          <SectionHeader title="Transfers" />
          <BookingTable
            headers={["Date", "Pickup Time", "From", "To", "Vehicle"]}
            data={packageData.transfers}
            renderRow={(transfer, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#F7FAFC" : "white",
                }}
              >
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {moment(transfer.date).format("MMM Do, YYYY")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.pickupTime}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.fromLocation}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.toLocation}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {transfer.vehicleDetails}
                </td>
              </tr>
            )}
          />
        </PageSection>
      )}

      {packageData.termsandConditions?.length > 0 && (
        <PageSection>
          <SectionHeader title="Terms & Conditions" />
          {packageData.termsandConditions.map((term, index) => (
            <div
              key={index}
              style={{ marginBottom: "10px", pageBreakInside: "avoid" }}
            >
              <h5 style={{ marginBottom: "5px" }}>{term.title}</h5>
              <p style={{ fontSize: "0.9rem", color: "#4A5568" }}>
                {term.description}
              </p>
            </div>
          ))}
        </PageSection>
      )}
    </div>
  );
};

export default Lead;
